import IAppStore from "app/IAppStore";
import Merchant from "domain/merchant";
import { useSelector } from "react-redux";

export default function useActiveMerchant(): Merchant {
    return useSelector((m: IAppStore) => m.userState.activeMerchant);
}